<template>
  <div>
    <el-navbar />
    <main class="container mt-5">
      <div class="bg-white py-4"></div>
      <div class="mt-5">
        <h2 class="my-3 text-primary">Impressum</h2>
        <h4>Angaben nach dem österreichischen Mediengesetz:</h4>
        <p>Mobile Tech Zone
          <br>USt-IdNr: ATU75170707
        </p>
        <p class="mb-0"><strong>Kontaktdaten:</strong></p>
        <p class="mb-0 small">
          <i class="fa-solid fa-sm fa-envelope text-primary"></i>
          <a title="Send Email" class="d-inline-block ms-2 nav-link p-0 text-black" href="mailto:info@mobiletechzone.at">info@mobiletechzone.at</a>
        </p>
        <p class="mb-0 small">
          <i class="fa-solid fa-sm fa-square-phone-flip text-primary"></i>
          <a title="Call us" class="d-inline-block ms-2 nav-link p-0 text-black" href="tel:+4369981170084">+43 699 81170084</a>
        </p>
        <p class="small">
          <i class="fa-solid fa-sm fa-location-dot text-primary"></i>
          <a title="Adresse" class="d-inline-block ms-2 nav-link p-0 text-black" href="https://goo.gl/maps/CXKDeZvPnneC33hR8">Landstraße Hauptstraße 92-94 1/2 1030, Wien</a>
        </p>
        <p>
          <strong>Rechtlicher Hinweis:</strong>
          <br>Es wurden alle zumutbaren Anstrengungen unternommen, um sicher zu stellen, dass die bereitgestellten Informationen richtig und vollständig sind.
          <br>Dennoch kann es zu Fehlern gekommen sein.
          <br> Daraus abgeleitete Ansprüche, welcher Art auch immer, können nicht anerkannt werden.
        </p>
        <p>
          <strong>Änderungen:</strong>
          <br>Der Herausgeber behält sich das Recht vor, Ergänzungen und/oder Änderungen der bereitgestellten Informationen, ohne vorherige Ankündigung, vorzunehmen.
        </p>
        <p>Copyright aller verwendetet Bilder von uns, Pexels, oder Unsplash</p>
        <p>
          <strong>Konzept, Design & Entwicklung:</strong>
          <br>
          <a href="https://abdulhamid.kwieder.com" target="_blank" rel="noopener noreferrer" title="Zur Abdulhamid Webseite">
            Abdulhamid Kwieder
            <i class="fa-solid fa-sm fa-arrow-up-right-from-square ms-1"></i>
          </a>
          & BE Code von
          <a href="https://bop-web.com/portfolio" target="_blank" rel="noopener noreferrer" title="Zur Moaz Webseite">
            Moaz Sabri
            <i class="fa-solid fa-sm fa-arrow-up-right-from-square ms-1"></i>
          </a>
        </p>
      </div>

    </main>
    <el-footer />
  </div>
</template>

<script>
import elNavbar from "../components/Navbar.vue";
import elFooter from "../components/Footer.vue";

export default {
  name: "Impressum",

  metaInfo() {
    return {
      title: "Impressum",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: { elNavbar, elFooter },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.utils.loaded = true;
    });
  },

  methods: {},
};
</script>

<style scoped></style>
